import Big from 'big.js';

import { AdvertisementFieldAccessor, NetFieldAccessor } from '~/api/field-accessors';
import type { CampaignTransferResponseV2 } from '~/api/v2/mall/campaign/transfer/campaign-id';
import type { OfferDetailResponseV2 } from '~/api/v2/mall/offer/campaign-id';
import type { ShopDetailResponseV2 } from '~/api/v2/mall/shop/campaign-id';
import type { AdvertisementV2 } from '~/api/v2/schemas/advertisement';
import type { CampaignInfoV2 } from '~/api/v2/schemas/campaign-info';
import { RewardTypeV2 } from '~/api/v2/schemas/reward-type';

export type CampaignData = CampaignInfoV2 | ShopDetailResponseV2 | OfferDetailResponseV2 | CampaignTransferResponseV2;

export type PointData = {
  isRate: boolean;
  value: Big | number;
  firstAd: AdvertisementV2 | null;
  regularValue: Big | number | undefined;
  hasPointup: boolean;
  hasMultiple: boolean;
};

/**
 * キャンペーンデータからポイント表示に必要な情報を抽出する
 * @param campaign - キャンペーンデータ
 * @returns ポイント表示に必要な情報
 */
export function getPointData(campaign: CampaignData): PointData {
  const isRate = 'reward_type' in campaign ? campaign.reward_type === RewardTypeV2.RATE : false;
  const firstAd = campaign.net.advertisement.length === 0 ? null : campaign.net.advertisement[0];

  // max_netが存在する場合は優先的に使用（0も有効な値として扱う）
  // max_netが未定義の場合はmin_netを使用（min_netは必須フィールド）
  const maxNet = NetFieldAccessor.maxNet(campaign.net);
  const minNet = NetFieldAccessor.minNet(campaign.net);
  const value = maxNet ?? minNet;

  // regularValueはfirstAdが存在し、regular_netが定義されている場合のみ値を返す
  const regularValue = firstAd ? AdvertisementFieldAccessor.regularNet(firstAd) : undefined;

  const hasPointup = Boolean(firstAd?.pointup_flg);
  const hasMultiple = campaign.net.advertisement.length > 1;

  return {
    isRate,
    value,
    firstAd,
    regularValue,
    hasPointup,
    hasMultiple,
  };
}
